import * as Accountant from 'app/calcs/Accountant'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { ICommonPensionInputs, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { ageAtAsDuration, deadBy, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'

interface INcpersPensionInputs extends ICommonPensionInputs {
  salaries: number[]
  yearsOfService: number
  formOfPayment: SimplePensionFormOfPayment
}

class NCPERSPensionCalculations extends CommonPensionCalculations<INcpersPensionInputs> {

  constructor(profile: Profile) {
    super(profile, 'NCPERS (current)')
  }

  getPension(): INcpersPensionInputs {
    return this.profile.pension.ncpers
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold()
  }

  getMonthlyPensionAmount(person: IRetirementPerson, vals: INcpersPensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {
    return Accountant.getNcpersMonthlyPensionAmount({ person, vals, when: null })
  }

}

export {
  INcpersPensionInputs,
  NCPERSPensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/ncpers/current/index.ts